import type { PropertyType } from '@/backend/types'
import { usePermissionsStore } from '@/modules/IdentityAndAccess/permissionsStore'
import type { Field } from '@/modules/Project/Fields/types'
import { toast } from '@/shared/toast'
import { useSetFieldValue } from '@/shared/useSetFieldValue'

export function useFieldSaving() {
  const permissionsStore = usePermissionsStore()
  function hasPermissionToUpdate() {
    return permissionsStore.currentProjectPermissions.update_entities
  }

  /**
   * Saves a manual field value to the entity.
   */
  async function saveFieldChange<T extends PropertyType>(
    field: Field<T>,
    newValue: Field<T>['manualValue'],
  ): Promise<void> {
    // eslint-disable-next-line internal/no-call-composable-outside-setup
    const setFieldValue = useSetFieldValue()

    if (!hasPermissionToUpdate()) {
      toast.error('You do not have permission to update this field.')
      return
    }

    const { ok: success } = await setFieldValue({ [field.propertyId]: { field, newValue } })

    if (!success) {
      toast.error('Failed to save value.')
    }
  }
  return { saveFieldChange }
}
